import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const MoveToPrivateFolderModal = ({ show, onHide, itemName, folderName, sharedUserCount, folderItemCount, onShareFolder, onMakePrivate, isLoading }) => {
  const userLabel = sharedUserCount === 1 ? 'user' : 'users'
  const itemLabel = folderItemCount === 1 ? 'item' : 'items'

  return (
    <Modal show={show} onHide={isLoading ? undefined : onHide} backdrop={isLoading ? 'static' : true} centered>
      <Modal.Header className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2 fs-5">
          <FontAwesomeIcon icon={faExclamationTriangle} className="text-warning" />
          Moving shared item to private folder
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{itemName}</strong> is shared with {sharedUserCount} {userLabel}. Moving it
          into <strong>{folderName}</strong> ({folderItemCount} {itemLabel}) will place it in a private folder that
          those users cannot access.
        </p>
        <p className="mb-0 text-muted">How would you like to proceed?</p>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex flex-column gap-2">
        <Button
          variant="primary"
          className="w-100"
          onClick={onShareFolder}
          disabled={isLoading}
        >
          Share the folder with {sharedUserCount} {userLabel}
        </Button>
        <Button
          variant="outline-danger"
          className="w-100"
          onClick={onMakePrivate}
          disabled={isLoading}
        >
          Make the item private and remove {sharedUserCount} {userLabel}
        </Button>
        <Button
          variant="light"
          className="w-100"
          onClick={onHide}
          disabled={isLoading}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MoveToPrivateFolderModal
